<template>
	<div>
		<footer id="store-footer" class="footer">
			<div>
				<div class="footer-body">
					<div class="columns is-centered">
						<div class="column is-hidden-mobile"> <img id="footer-logo"
								src="@/assets/footer/footer-logo.png" alt="footer logo"> </div>
						<div class="column">
							<h4 class="footer-header is-size-4 has-text-weight-bold">FRANCHISING</h4>
							<ul id="menu-franchising" class="menu">
								<li id="menu-item-11828"
									class="menu-item menu-item-type-post_type menu-item-object-page menu-item-11828"><a
										rel="noopener" href="https://www.pizzaguys.com/franchising/our-brand/">Our
										Brand</a></li>
								<li id="menu-item-11824"
									class="menu-item menu-item-type-post_type menu-item-object-page menu-item-11824"><a
										rel="noopener" href="https://www.pizzaguys.com/franchising/our-leadership/">Our
										Leadership</a></li>
								<li id="menu-item-11977"
									class="menu-item menu-item-type-post_type menu-item-object-page menu-item-11977"><a
										rel="noopener"
										href="https://www.pizzaguys.com/franchising/franchise-process/">Franchise
										Process</a></li>
								<li id="menu-item-11982"
									class="menu-item menu-item-type-post_type menu-item-object-page menu-item-11982"><a
										rel="noopener"
										href="https://www.pizzaguys.com/franchising/investment/">Investment</a></li>
								<li id="menu-item-12209"
									class="menu-item menu-item-type-post_type menu-item-object-page menu-item-12209"><a
										rel="noopener"
										href="https://www.pizzaguys.com/franchising/franchisee-support/">Franchisee
										Support</a></li>
								<li id="menu-item-11826"
									class="menu-item menu-item-type-post_type menu-item-object-page menu-item-11826"><a
										rel="noopener"
										href="https://www.pizzaguys.com/franchising/available-locations/">Available
										Locations</a></li>
								<li id="menu-item-11825"
									class="menu-item menu-item-type-post_type menu-item-object-page menu-item-11825"><a
										rel="noopener"
										href="https://www.pizzaguys.com/franchising/franchisee-application/">Franchisee
										Application</a></li>
							</ul>
						</div>
						<div class="column">
							<h4 class="footer-header is-size-4 has-text-weight-bold">ABOUT US</h4>
							<ul id="menu-about-us" class="menu">
								<li id="menu-item-11811"
									class="menu-item menu-item-type-post_type menu-item-object-page menu-item-11811"><a
										rel="noopener" href="https://www.pizzaguys.com/about/our-history/">Our
										History</a></li>
								<li id="menu-item-11810"
									class="menu-item menu-item-type-post_type menu-item-object-page menu-item-11810"><a
										rel="noopener" href="https://www.pizzaguys.com/about/careers/">Careers</a></li>
								<li id="menu-item-11800"
									class="menu-item menu-item-type-custom menu-item-object-custom menu-item-11800"><a
										rel="noopener" href="/nutritional-information/speciality-pizzas">Nutrition</a>
								</li>
								<li id="menu-item-12877"
									class="menu-item menu-item-type-post_type menu-item-object-page menu-item-12877"><a
										rel="noopener" href="https://www.pizzaguys.com/faq">FAQ</a></li>
								<li id="menu-item-12186"
									class="menu-item menu-item-type-post_type menu-item-object-page menu-item-12186"><a
										rel="noopener" href="https://www.pizzaguys.com/about/press/">Press</a></li>
								<li id="menu-item-12605"
									class="menu-item menu-item-type-custom menu-item-object-custom menu-item-12605"><a
										target="_blank" rel="noopener"
										href="https://mgd.mercury-gift.com/pizzaguys/Index">Gift Card Balance</a></li>
								<li id="menu-item-12187"
									class="menu-item menu-item-type-post_type menu-item-object-page menu-item-12187"><a
										rel="noopener" href="https://www.pizzaguys.com/contact-us">Contact</a></li>
							</ul>
						</div>
						<div class="column">
							<h4 class="footer-header is-size-4 has-text-weight-bold">NEVER MISS A DEAL!</h4>
							<p>Receive special discounts and exclusive offers you won't find anywhere else!</p>
							<div class="eclub-cta" @click="goToPromotionalOffers()">
								<BaseButton :classNames="['square-btn']">
									<BaseIcon :classNames="['envelope']" icon='envelope' size='1x' />
									<span class="eclub-cta-join">JOIN ECLUB!</span>
								</BaseButton>
							</div>
							<div id="social-section">
								<h4 class="footer-header is-size-4 has-text-weight-bold">CONNECT WITH US!</h4>
								<div class="social-icon-container"> <a
										href="https://www.facebook.com/realpizzarealvalue"
										aria-label="Pizza Guys on Facebook" target="_blank" rel="noopener">
										<BaseIcon :classNames="['social-icon']" icon="facebook" size="2x" /></a> <a
										href="https://www.instagram.com/pizzaguysofficial/"
										aria-label="Pizza Guys on Instagram" target="_blank" rel="noopener">
										<BaseIcon :classNames="['social-icon']" icon="instagram" size="2x" /></a> <a
										href="https://www.linkedin.com/company/1805106"
										aria-label="Pizza Guys on LinkedIn" target="_blank" rel="noopener">
										<BaseIcon :classNames="['social-icon']" icon="linkedIn" size="2x" /></a> <a
										href="https://twitter.com/PizzaGuys" aria-label="Pizza Guys on Twitter"
										target="_blank" rel="noopener">
										<BaseIcon :classNames="['social-icon']" icon="twitter" size="2x" /></a> <a
										href="https://www.pinterest.com/pizzaguys/" aria-label="Pizza Guys on Pinterest"
										target="_blank" rel="noopener">
										<BaseIcon :classNames="['social-icon']" icon="pinterest" size="2x" /></a>
									<!-- <a href="" target="_blank"><BaseIcon :classNames="['social-icon']" icon="googlePlus" size="2x" /></a> -->
								</div>
							</div>
						</div>
					</div>
					<div class="columns is-centered copyright-section">
						<div class="column">
							<p class="has-text-centered is-size-7">Copyright © {{currentYear}} <span
									v-if="franchisor && franchisor.paymentLoyaltyFlowModel">{{franchisor.paymentLoyaltyFlowModel.localMarketingName}}</span>
								Franchises, Inc. All Rights Reserved.</p>
						</div>
					</div>
				</div>
			</div>
		</footer>
		<tp-footer />
	</div>
</template>

<script>
import TPFooter from '@/components/footer/TPFooter';
import footerMixin from '@Mixin/footerMixin';
 
export default {
	mixins: [footerMixin],
	components: {
		'tp-footer': TPFooter,
	},
	methods: {
		style() {
			const mobile = this.$isMobile;
			return {
				mobile,
				desktop: !mobile,
			};
		},
		goToPromotionalOffers() {
			window.open('https://www.pizzaguys.com/promotional-offers/', '_blank');
		},
	},
};
</script>

<style lang="scss" scoped>
	@import '@style-vars';

	.flex {
		display: flex;
		justify-content: center;
		align-items: center;
		margin-top: 1em;
	}

	#footer-logo {
		width: 220px;
		padding: 3px;
		margin-top: 2em;
	}

	.footer-body {
		max-width: 1175px;
		margin: auto;
	}

	#social-section {
		margin-top: 2em;
		margin: auto;
	}

	#social-section div {
		display: inline;
		padding-right: 0.8em;
	}

	.social-icon {
		font-size: 12px;
		color: #232220;
	}

	.social-icon-container {
		margin: auto;
	}

	.copyright-section {
		margin-top: 3em;
	}

	.eclub-cta {
		margin-top: 0.8em;
		margin-bottom: 2em;
		.eclub-cta-join {
			padding-left: 0.5em;
		}
	}

	.envelope {
		padding-right: 0.3em;
	}

	.wrapper {
		padding: 20px;
	}

	.in-text {
		padding: 0 10px;
	}

	.fallback-text {
		margin-left: 1em;
	}

	.text-center {
		text-align: center;
	}

	#store-footer {
		background-color: #ffffff;
		background-image: url("../../assets/footer/footer-background.png");
		background-repeat: no-repeat;
		background-position: center center;
		padding-top: 80px;
		padding-bottom: 20px;
		background-size: auto;
		min-height: 508px;
	}

	.footer-header {
		margin-top: 15px;
		margin-bottom: 15px;
		text-transform: uppercase;
		color: $storeButtonColor;
	}

	/* --- */

	#store-footer {
		background-color: #ffffff;
	}

	#store-footer li {
		padding: 3px 0px;
	}

	.store-footer.side-bar {
		margin-left: 20vw;
		width: 80vw;
	}

	#store-footer.desktop-size {
		margin-top: 40px;
		padding-bottom: 0;
	}

	#store-footer.mobile {
		position: relative;
		margin-top: 40px;
		padding-top: 0;
	}
</style>



// WEBPACK FOOTER //
// src/components/footer/AppFooter.vue